module.exports = __webpack_public_path__ + "static/media/400118_01.de52ac03.png";